import { render, staticRenderFns } from "./RemainingInstallmentsPaymentModal.vue?vue&type=template&id=152f203e&"
import script from "./RemainingInstallmentsPaymentModal.vue?vue&type=script&lang=js&"
export * from "./RemainingInstallmentsPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports